import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltipable from '~/components/effects/tooltipable';

/**
 * Button to expand/collapse email thread replies
 * @param {object} props - Component properties
 * @param {boolean} props.expanded - Whether the view is currently expanded
 * @param {Function} props.onClick - Function to toggle the expanded view
 * @param {string} [props.bgColor="bg-light"] - Background color CSS class
 * @returns {JSX.Element} - The button element
 */
const ExpandThreadButton = ({ expanded, onClick, bgColor = 'bg-light' }) => (
  <Tooltipable text={expanded ? 'Hide thread' : 'Show thread'} placement="bottom">
    <button
      className={`btn btn-link shadow-none p-0 mt-2 rounded-pill d-inline-flex align-items-center justify-content-center ${bgColor} text-secondary`}
      onClick={onClick}
      aria-label={expanded ? 'Hide thread' : 'Show thread'}
      type="button"
      style={{ width: '24px' }}
    >
      <FontAwesomeIcon icon="ellipsis-h" size="xs" />
    </button>
  </Tooltipable>
);

ExpandThreadButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClick:  PropTypes.func.isRequired,
  bgColor:  PropTypes.string,
};

export default ExpandThreadButton;
